module.exports = __webpack_public_path__ + "static/media/8.1.3.4.yandex_stanciya_radio.0359c59a.png";